import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import {
  formatLongDate,
  formatRelativeDate,
  formatShortDate,
  formatShortWeekDay,
  formatTime,
  formatTimeAgo,
  formatTimeSeconds,
} from "./formatters/date";
import { formatPhoneNumber } from "./formatters/phoneNumber";
import enTranslation from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
    },
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
  });

// Custom formatters
i18n.services.formatter?.add("shortDate", (value, lng) =>
  formatShortDate(value, lng),
);
i18n.services.formatter?.add("shortWeekDay", (value, lng) =>
  formatShortWeekDay(value, lng),
);
i18n.services.formatter?.add("longDate", (value, lng, options) =>
  formatLongDate(value, lng, options),
);
i18n.services.formatter?.add("relativeDate", (value, lng) =>
  formatRelativeDate(value, lng),
);
i18n.services.formatter?.add("time", (value, lng) => formatTime(value, lng));
i18n.services.formatter?.add("timeSeconds", (value, lng) =>
  formatTimeSeconds(value, lng),
);
i18n.services.formatter?.add("timeAgo", (value, lng) =>
  formatTimeAgo(value, lng),
);
i18n.services.formatter?.add("phoneNumber", (value, lng) =>
  formatPhoneNumber(value, lng),
);

export default i18n;
